import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../utilities/LogErrors'
import { useLanguage } from './../../utilities/LanguageContext'

//Funciones personalizadas
import { SaveWebTheme, SaveWebFontSize, GetUserData as BLGetUserData, UpdateNickname as BLUpdateNickname } from './../../utilities/BL/Settings'
import { Logout as BLLogout } from './../../utilities/BL/Sessions'

import { ChangeProfile as BLChangeProfile } from './../../utilities/BL/Navigation'

import { useFloatMessage, MESSAGE_TYPE } from './../Providers/FloatMessage'
import { Details } from './../Common/Modals/Details'

import { Dashboard as HelpZtudentDashboard } from './../../Support/Ztudent/Dashboard'
import { Course as HelpZtudentCourse } from './../../Support/Ztudent/Course'
import { Results as HelpZtudentResults } from './../../Support/Ztudent/Results'

import { Dashboard as HelpInstructorDashboard } from './../../Support/Instructor/Dashboard'
import { Groups as HelpInstructorGroups } from './../../Support/Instructor/Groups'
import { Create as HelpInstructorGroupsCreate } from './../../Support/Instructor/Group/Create'
import { Group as HelpInstructorGroup } from './../../Support/Instructor/Group'
import { Ztudents as HelpInstructorZtudents } from './../../Support/Instructor/Ztudents'
import { ChangeGroup as HelpInstructorChangeGroup } from './../../Support/Instructor/ChangeGroup'
import { Agenda as HelpInstructorAgenda } from './../../Support/Instructor/Agenda'
import { Progress as HelpInstructorProgress } from './../../Support/Instructor/Progress'
import { Results as HelpInstructorResults } from './../../Support/Instructor/Results'
import { ZtudentView as HelpInstructorZtudentView } from './../../Support/Instructor/ZtudentView'
import { Syllabus as HelpInstructorSyllabus } from './../../Support/Instructor/Syllabus'

import { Confirm } from './../Common/Modals/Confirm'
import { HELP_TYPE } from './../../utilities/EL/HelpType'


// const HELP_TYPE = {
//     ZTUDENT: {
//         DASHBOARD: 1,
//         COURSE: 13,
//         RESULTS: 14
//     },
//     INSTRUCTOR: {
//         DASHBOARD: 2,
//         GROUPS: 3,
//         GROUPS_CREATE: 4,
//         GROUP: 5,
//         ZTUDENTS: 6,
//         CHANGE_GROUP: 7,
//         AGENDA: 8,
//         PROGRESS: 9,
//         RESULTS: 10,
//         ZTUDENTVIEW: 11,
//         SYLLABUS: 12
//     }
// }

const Header = ({ text, theme, propositionValue = null, idHelp = null }) => {
    const { translate } = useLanguage() // 🔹 Función de traducción desde el contexto
    const navigate = useNavigate()
    const { showMessage } = useFloatMessage()

    // --- Tema (light/dark) ---
    const [theTheme, setTheTheme] = useState(null)

    // --- Modales existentes ---
    const [showPropositionValueModal, setShowPropositionValueModal] = useState(false)
    const [showHelpModal, setShowHelpModal] = useState(false)
    const [showMyAccountModal, setShowMyAccountModal] = useState(false)
    const [userData, setUserData] = useState(false)

    // --- NUEVOS estados para editar alias / nickname ---
    const [showEditNicknameModal, setShowEditNicknameModal] = useState(false)      // Modal para capturar el nuevo alias
    const [showConfirmNicknameModal, setShowConfirmNicknameModal] = useState(false) // Modal de confirmación
    const [nicknameInput, setNicknameInput] = useState('')                         // Valor que se escribe en el input
    const [pendingNickname, setPendingNickname] = useState(null)                   // Alias pendiente de guardar (para confirmar)
    const [isSavingNickname, setIsSavingNickname] = useState(false)                // Bandera mientras se guarda en el servidor

    const typePropositionValue = {
        ZTUDENT: 1,
        INSTRUCTOR: 2
    }
    
    /**
     * Cambia el tema visual de la plataforma (claro/oscuro)
     * y lo guarda en el backend.
     */
    const ChangeTheme = async (idThemeToSave) => {
        try {
            const response = await SaveWebTheme(idThemeToSave)
            
            if (response.success) {
                setTheTheme(response.data)
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('ChangeTheme - Header', error)
        }
    }

    /**
     * Cambia el tamaño de fuente general de la interfaz
     * y lo guarda en el backend.
     */
    const ChangeFontSize = async (idFontSize) => {
        try {
            const response = await SaveWebFontSize(idFontSize)

            if (!response.success) {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('ChangeFontSize - Header', error)
        }
    }

    /**
     * Cambia el centro/perfil del usuario.
     */
    const ChangeProfile = async () => {
        try {
            const response = await BLChangeProfile()

            if (response.success) {
                navigate('/')
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('ChangeProfile - Header', error)
        }
    }

    /**
     * Cierra la sesión actual del usuario.
     */
    const Logout = async () => {
        try {
            const response = await BLLogout()

            if (response.success) {
                if (response.data === null) {
                    navigate("/")
                } else {
                    console.log(response.message)
                }
            } else {
                console.log(response.message)
            }
        } catch (error) {
            await LogErrors('Logout - Header', error)
        }
    }

    /**
     * Carga la información inicial del header:
     * - Tema actual
     * - Datos de la cuenta del usuario
     */
    const LoadPage = async () => {
        try {
            setTheTheme(theme)

            // Obtener los datos de la cuenta del usuario
            const response = await BLGetUserData()

            if (response.success) {
                setUserData(response.data)
            }
        } catch (error) {
            await LogErrors('LoadPage - Header', error)
        }
    }

    /**
     * Abre el modal para editar el alias.
     * Precarga el alias actual en el input.
     */
    const OpenEditNicknameModal = async () => {
        try {
            if (!userData) return

            // Usamos el alias actual como valor inicial
            setNicknameInput(userData.nickname ?? '')
            setShowEditNicknameModal(true)
        } catch (error) {
            await LogErrors('OpenEditNicknameModal - Header', error)
        }
    }

    /**
     * Maneja el clic en "Guardar cambios" dentro del modal de edición.
     * No guarda todavía en el servidor, solo:
     * - Valida el texto
     * - Guarda el alias pendiente
     * - Muestra el modal de confirmación
     */
    const HandleNicknameSubmit = async () => {
        try {
            if (!userData) return

            const trimmedNickname = (nicknameInput ?? '').trim()

            // Validar que no esté vacío
            if (!trimmedNickname) {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: 'Debes escribir un alias para poder cambiarlo'
                })
                return
            }

            // Si no cambia nada, no tiene sentido confirmar ni llamar al backend
            const currentNickname = (userData.nickname ?? '').trim()
            if (trimmedNickname === currentNickname) {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: 'Escribe tu nuevo alias' //No has realizado ningún cambio en tu alias
                })
                return
            }

            // Guardamos el alias pendiente y mostramos el modal de confirmación
            setPendingNickname(trimmedNickname)
            setShowEditNicknameModal(false)
            setShowConfirmNicknameModal(true)
        } catch (error) {
            await LogErrors('HandleNicknameSubmit - Header', error)
        }
    }

    /**
     * Envía la petición al backend para actualizar el alias del usuario.
     * Utiliza la función BLUpdateNickname (ya existente en la capa BL).
     */
    const UpdateNickname = async () => {
        try {
            if (!pendingNickname) return

            setIsSavingNickname(true)

            const response = await BLUpdateNickname(pendingNickname)

            if (response.success) {
                // Mostrar mensaje de éxito
                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: 'Se ha actualizado tu alias de manera exitosa'
                })

                // Actualizar el alias en el estado local para reflejar el cambio en pantalla
                setUserData(prev => {
                    if (!prev) return prev
                    return {
                        ...prev,
                        nickname: pendingNickname
                    }
                })
            } else {
                // Mostrar mensaje de error regresado por el backend
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('UpdateNickname - Header', error)
            showMessage({
                type: MESSAGE_TYPE.BAD,
                text: 'No ha sido posible actualizar tu alias. Inténtalo nuevamente o inténtalo más tarde'
            })
        } finally {
            // Cerrar modal de confirmación y limpiar estados
            setIsSavingNickname(false)
            setShowConfirmNicknameModal(false)
            setPendingNickname(null)
        }
    }

    useEffect(() => {
        LoadPage()
    },[])
    

    return (
        <header className="container Header">
            <div className="Header-Side1">
                <div className="Header-Brand">
                    {theTheme && theTheme === 2 ? (
                        <img src="/img/brand/Ztudia-Logotipo-Blanco-66x26.png" className="Header-Image" />
                    ) : (
                        <img src="/img/brand/Ztudia-Logotipo-Negro-66x26.png" className="Header-Image" />
                    )}
                </div>
            </div>

            {text !== '' && (
                <div className="Header-Side2">
                    <p className="Header-Text">{text}</p>
                </div>
            )}

            <div className="Header-Side3">
                <div className="Header-Menu btn-group">
                    {propositionValue && (
                        <button type='button' className='Header-Menu-Button small' onClick={() => setShowPropositionValueModal(true)}>
                            {/* <i className="bi bi-info-circle"></i> Propuesta de valor */}
                            <i className="bi bi-file-earmark"></i> Propuesta de valor
                        </button>
                    )}

                    {idHelp && (
                        <button type='button' className='Header-Menu-Button' onClick={() => setShowHelpModal(true)}>
                            <i className="bi bi-question-circle"></i> Ayuda
                        </button>
                    )}

                    <button type="button" className="dropdown-toggle Header-Menu-Button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="bi bi-person-circle"></i>
                    </button>
                    
                    <ul className="dropdown-menu dropdown-menu-end Header-Menu-Options">
                        <li>
                            {theTheme && theTheme === 2 ? (
                                <button className="dropdown-item" type="button" onClick={() => ChangeTheme(1)}>
                                    <i className="bi bi-sun"></i> {translate('labels.header.themes.light')}
                                </button>
                            ) : (
                                <button className="dropdown-item" type="button" onClick={() => ChangeTheme(2)}>
                                    <i className="bi bi-moon"></i> {translate('labels.header.themes.dark')}
                                </button>
                            )}
                        </li>
                        <li className="dropdown-item Header-Menu-Options-Size">
                            <span className="Header-Menu-Options-Size-Small" onClick={() => ChangeFontSize("SmallFont")}>A</span>
                            <span className="Header-Menu-Options-Size-Medium" onClick={() => ChangeFontSize("MediumFont")}>A</span>
                            <span className="Header-Menu-Options-Size-Big" onClick={() => ChangeFontSize("BigFont")}>A</span>
                        </li>
                        <li>
                            <button className="dropdown-item" type="button" onClick={ChangeProfile}><i className="bi bi-person"></i> Cambiar centro/perfil</button>
                        </li>
                        <li>
                            <button className="dropdown-item" type="button" onClick={() => setShowMyAccountModal(true)}><i className="bi bi-person-circle"></i> Ver mi cuenta</button>
                        </li>
                        <li>
                            <button className="dropdown-item" type="button" onClick={() => Logout()}><i className="bi bi-box-arrow-right"></i> {translate('labels.header.logout')}</button>
                        </li>
                    </ul>
                </div>
            </div>

            {/* ======================= MODAL PROPUESTA DE VALOR ======================= */}
            {showPropositionValueModal && (
                <Details
                    showCloseModalButtonInContent={true}
                    extraClassName={'Instructor__Ztudents__Details'}
                    setShowModal={setShowPropositionValueModal}
                >
                    <div className='Instructor__Ztudents__Details__Container'>
                        <p className='Instructor__Ztudents__Details__Title'>Propuesta de valor</p>

                        {propositionValue === typePropositionValue.ZTUDENT ? (
                            <>
                                <p>Ztudia es una solución educativa que te acompaña en el desarrollo de habilidades digitales esenciales para tu formación académica y profesional.</p>
                                <p>A través de un recorrido estructurado por niveles, aprenderás a dominar herramientas como Word, Excel, PowerPoint, Photoshop, programación y desarrollo web.</p>
                                <p>Cada bloque de contenido incluye teoría clara, videos explicativos, cuestionarios interactivos y desafíos prácticos que te permiten aplicar lo aprendido de forma dinámica y significativa.</p>
                                <p>Además, participarás en actividades grupales que fortalecen tu comprensión y fomentan el trabajo colaborativo.</p>
                                <p>Tu docente es quien guía tu proceso: establece cuándo iniciar cada bloque, activa los contenidos y da seguimiento a tu avance.</p>
                                <p>Las evaluaciones se aplican y califican automáticamente, y puedes consultar tus resultados desde tu perfil.</p>
                                <p>Con Ztudia, aprendes a tu ritmo, con autonomía, pero siempre acompañado.</p>
                            </>
                        ) : propositionValue === typePropositionValue.INSTRUCTOR && (
                            <>
                                <p>Ztudia es una solución educativa diseñada para facilitar la enseñanza de competencias digitales mediante una estructura clara, completa y lista para usar.</p>
                                <p>Ofrece un temario progresivo, organizado por bloques de conocimiento que cubren herramientas clave como Word, Excel, PowerPoint, Photoshop, Principios de Programación, Programación Orientada a Objetos y Desarrollo Web.</p>
                                <p>Cada bloque incluye contenido teórico, cuestionarios, videos y desafíos prácticos, todo previamente diseñado para que el docente pueda implementarlo directamente en el aula sin necesidad de crear materiales adicionales.</p>
                                <p>Además, incorpora actividades grupales estructuradas que refuerzan el aprendizaje colaborativo, y evaluaciones que se aplican y califican automáticamente, mostrando los resultados en los perfiles del docente y del alumno.</p>
                                <p>El docente solo necesita definir fechas y activar los contenidos, lo que simplifica la planificación y ejecución de sus clases.</p>
                                <p>Esta automatización y estructura permiten optimizar el tiempo del docente, facilitar la gestión pedagógica y fortalecer la calidad del proceso de enseñanza-aprendizaje.</p>
                            </>
                        )}
                    </div>
                </Details>
            )}

            {/* ======================= MODAL DE AYUDA ======================= */}
            {showHelpModal && (
                <Details
                    showCloseModalButtonInContent={false}
                    extraClassName={'Instructor__Ztudents__Details'}
                    setShowModal={setShowHelpModal}
                >
                    <div className='Instructor__Ztudents__Details__Container'>
                        <p className='Instructor__Ztudents__Details__Title'><i className="bi bi-question-circle"></i> Ayuda</p>

                        {idHelp === HELP_TYPE.ZTUDENT.DASHBOARD ? (
                            <HelpZtudentDashboard />
                        ) : idHelp === HELP_TYPE.ZTUDENT.COURSE ? (
                            <HelpZtudentCourse />
                        ) : idHelp === HELP_TYPE.ZTUDENT.RESULTS ? (
                            <HelpZtudentResults />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUPS ? (
                            <HelpInstructorGroups />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUPS_CREATE ? (
                            <HelpInstructorGroupsCreate />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUP ? (
                            <HelpInstructorGroup />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.ZTUDENTS ? (
                            <HelpInstructorZtudents />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.CHANGE_GROUP ? (
                            <HelpInstructorChangeGroup />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.AGENDA ? (
                            <HelpInstructorAgenda />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.PROGRESS ? (
                            <HelpInstructorProgress />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.RESULTS ? (
                            <HelpInstructorResults />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.ZTUDENTVIEW ? (
                            <HelpInstructorZtudentView />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.SYLLABUS ? (
                            <HelpInstructorSyllabus />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.DASHBOARD && (
                            <HelpInstructorDashboard />
                        )}
                    </div>
                </Details>
            )}

            {/* ======================= MODAL MI CUENTA ======================= */}
            {showMyAccountModal && (
                userData ? (
                    <Details
                        showCloseModalButtonInContent={false}
                        extraClassName={'Instructor__Ztudents__Details'}
                        setShowModal={setShowMyAccountModal}
                    >
                        <div className='Instructor__Ztudents__Details__Container'>
                            <p className='Instructor__Ztudents__Details__Title'>Mi cuenta</p>

                            <p>Nombre completo: {userData.name}</p>
                            <p>Correo electrónico: {userData.email}</p>

                            {/* Fila de alias + botón para editar */}
                            <p>
                                Alias: {userData.nickname}
                                <button type='button' className='Btn__Ztudia--PrimaryOutline Instructor__Header__EditButtons' onClick={OpenEditNicknameModal}>
                                    <i className="bi bi-pencil"></i>
                                </button>
                            </p>
                        </div>
                    </Details>
                ) : (
                    <Details
                        showCloseModalButtonInContent={false}
                        extraClassName={'Instructor__Ztudents__Details'}
                        setShowModal={setShowMyAccountModal}
                    >
                        <div className='Instructor__Ztudents__Details__Container'>
                            <p>No ha sido posible obtener la información de tu cuenta.</p>
                            <p>Inténtalo nuevamente o inténtalo más tarde.</p>
                        </div>
                    </Details>
                )
            )}

            {/* ======================= MODAL EDITAR ALIAS ======================= */}
            {showEditNicknameModal && (
                <Details
                    showCloseModalButtonInContent={false}
                    extraClassName={'Instructor__Ztudents__Details'}
                    setShowModal={setShowEditNicknameModal}
                >
                    <div className='Instructor__Ztudents__Details__Container'>
                        <p className='Instructor__Ztudents__Details__Title'>Editar alias</p>

                        <p>Alias actual:</p>
                        <p>{userData?.nickname ?? 'Aún no has establecido un alias'}</p>
                        
                        <label htmlFor='nicknameInput'>Nuevo alias:</label>
                        <input id='nicknameInput' type='text' className='Instructor__Header__Modal--Edit__Input' value={nicknameInput} onChange={(e) => setNicknameInput(e.target.value)} />

                        <div className='Instructor__Groups__Modal--Edit__Buttons'>
                            <button type='button' className='Btn__Ztudia--Primary Instructor__Groups__Modal--Edit__Buttons__Button' onClick={HandleNicknameSubmit}>Guardar cambios</button>
                            <button type='button' className='Btn__Ztudia--DangerOutline Instructor__Groups__Modal--Edit__Buttons__Button' onClick={() => setShowEditNicknameModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </Details>
            )}

            {/* ======================= MODAL CONFIRMACIÓN ALIAS ======================= */}
            {showConfirmNicknameModal && pendingNickname && (
                <Confirm
                    // Mostramos alias actual (A) y alias nuevo (B)
                    message={`¿Estás segur@ de cambiar el alias ${userData?.nickname ? ` '${userData?.nickname}' ` : ''}a '${pendingNickname}'?`}
                    actionToYesButton={UpdateNickname}
                    textYesButton={isSavingNickname ? 'Guardando...' : 'Sí, cambiar alias ahora'}
                    textNoButton={'No'}
                    setShowModal={setShowConfirmNicknameModal}
                    setConfirmData={setPendingNickname}
                />
            )}
        </header>
    )
}

export { Header };











// const HELP_TYPE = {
//     ZTUDENT: {
//         DASHBOARD: 1,
//         COURSE: 13,
//         RESULTS: 14
//     },
//     INSTRUCTOR: {
//         DASHBOARD: 2,
//         GROUPS: 3,
//         GROUPS_CREATE: 4,
//         GROUP: 5,
//         ZTUDENTS: 6,
//         CHANGE_GROUP: 7,
//         AGENDA: 8,
//         PROGRESS: 9,
//         RESULTS: 10,
//         ZTUDENTVIEW: 11,
//         SYLLABUS: 12
//     }
// }

// const Header = ({ text, theme, propositionValue = null, idHelp = null }) => {
//     const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
//     const navigate = useNavigate()
//     const { showMessage } = useFloatMessage()

//     const [theTheme, setTheTheme] = useState(null)

//     const [showPropositionValueModal, setShowPropositionValueModal] = useState(false)
//     const [showHelpModal, setShowHelpModal] = useState(false)
//     const [showMyAccountModal, setShowMyAccountModal] = useState(false)
//     const [userData, setUserData] = useState(false)

//     const typePropositionValue = {
//         ZTUDENT: 1,
//         INSTRUCTOR: 2
//     }
    

//     const ChangeTheme = async (idThemeToSave) => {
//         try {
//             const response = await SaveWebTheme(idThemeToSave)
            
//             if (response.success) {
//                 setTheTheme(response.data)
//             } else {
//                 showMessage({
//                     type: MESSAGE_TYPE.BAD,
//                     text: response.message
//                 })
//                 //console.log(response.message)
//             }
//         } catch (error) {
//             await LogErrors('ChangeTheme - Header', error)
//         }
//     }

//     const ChangeFontSize = async (idFontSize) => {
//         try {
//             const response = await SaveWebFontSize(idFontSize)

//             if (!response.success) {
//                 showMessage({
//                     type: MESSAGE_TYPE.BAD,
//                     text: response.message
//                 })
//                 //console.log(response.message)
//             }
//         } catch (error) {
//             await LogErrors('ChangeFontSize - Header', error)
//         }
//     }

//     const ChangeProfile = async () => {
//         try {
//             const response = await BLChangeProfile()

//             if (response.success) {
//                 navigate('/')
//             } else {
//                 showMessage({
//                     type: MESSAGE_TYPE.BAD,
//                     text: response.message
//                 })
//             }
//         } catch (error) {
            
//         }
//     }

//     const Logout = async () => {
//         try {
//             const response = await BLLogout()

//             if (response.success) {
//                 if (response.data === null) {
//                     navigate("/")
//                 } else {
//                     console.log(response.message)
//                 }
//             } else {
//                 //Mostrar mensaje de que no se pudo cerrar la sesión correctamente. Intenta nuevamente o más tarde.
//                 //En un componente de mensajes
//                 console.log(response.message)
//             }
//         } catch (error) {
//             await LogErrors('Logout - Header', error)
//         }
//     }

//     const LoadPage = async () => {
//         try {
//             setTheTheme(theme)

//             // Obtener los datos de la cuenta del usuario
//             const response = await BLGetUserData()

//             if (response.success) {
//                 setUserData(response.data)
//             }
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         LoadPage()
//     },[])
    

//     return (
//         <header className="container Header">
//             <div className="Header-Side1">
//                 <div className="Header-Brand">
//                     {theTheme && theTheme === 2 ? (
//                         <img src="/img/brand/Ztudia-Logotipo-Blanco-66x26.png" className="Header-Image" />
//                     ) : (
//                         <img src="/img/brand/Ztudia-Logotipo-Negro-66x26.png" className="Header-Image" />
//                     )}
//                 </div>
//             </div>

//             {text !== '' && (
//                 <div className="Header-Side2">
//                     <p className="Header-Text">{text}</p>
//                 </div>
//             )}

//             <div className="Header-Side3">
//                 <div className="Header-Menu btn-group">
//                     {propositionValue && (
//                         <button type='button' className='Header-Menu-Button small' onClick={() => setShowPropositionValueModal(true)}>
//                             {/* <i className="bi bi-info-circle"></i> Propuesta de valor */}
//                             <i className="bi bi-file-earmark"></i> Propuesta de valor
//                         </button>
//                     )}

//                     {idHelp && (
//                         <button type='button' className='Header-Menu-Button' onClick={() => setShowHelpModal(true)}>
//                             <i className="bi bi-question-circle"></i> Ayuda
//                         </button>
//                     )}

//                     <button type="button" className="dropdown-toggle Header-Menu-Button" data-bs-toggle="dropdown" aria-expanded="false">
//                         <i className="bi bi-person-circle"></i>
//                     </button>
                    
//                     <ul className="dropdown-menu dropdown-menu-end Header-Menu-Options">
//                         <li>
//                             {theTheme && theTheme === 2 ? (
//                                 <button className="dropdown-item" type="button" onClick={() => ChangeTheme(1)}>
//                                     <i className="bi bi-sun"></i> {translate('labels.header.themes.light')}
//                                 </button>
//                             ) : (
//                                 <button className="dropdown-item" type="button" onClick={() => ChangeTheme(2)}>
//                                     <i className="bi bi-moon"></i> {translate('labels.header.themes.dark')}
//                                 </button>
//                             )}
//                         </li>
//                         <li className="dropdown-item Header-Menu-Options-Size">
//                             <span className="Header-Menu-Options-Size-Small" onClick={() => ChangeFontSize("SmallFont")}>A</span>
//                             <span className="Header-Menu-Options-Size-Medium" onClick={() => ChangeFontSize("MediumFont")}>A</span>
//                             <span className="Header-Menu-Options-Size-Big" onClick={() => ChangeFontSize("BigFont")}>A</span>
//                         </li>
//                         <li>
//                             <button className="dropdown-item" type="button" onClick={ChangeProfile}><i className="bi bi-person"></i> Cambiar centro/perfil</button>
//                         </li>
//                         <li>
//                             <button className="dropdown-item" type="button" onClick={() => setShowMyAccountModal(true)}><i className="bi bi-person-circle"></i> Ver mi cuenta</button>
//                         </li>
//                         <li>
//                             <button className="dropdown-item" type="button" onClick={() => Logout()}><i className="bi bi-box-arrow-right"></i> {translate('labels.header.logout')}</button>
//                         </li>
//                     </ul>
//                 </div>
//             </div>

//             {showPropositionValueModal && (
//                 <Details
//                     showCloseModalButtonInContent={true}
//                     extraClassName={'Instructor__Ztudents__Details'}
//                     setShowModal={setShowPropositionValueModal}
//                 >
//                     <div className='Instructor__Ztudents__Details__Container'>
//                         <p className='Instructor__Ztudents__Details__Title'>Propuesta de valor</p>

//                         {propositionValue === typePropositionValue.ZTUDENT ? (
//                             <>
//                                 <p>Ztudia es una solución educativa que te acompaña en el desarrollo de habilidades digitales esenciales para tu formación académica y profesional.</p>
//                                 <p>A través de un recorrido estructurado por niveles, aprenderás a dominar herramientas como Word, Excel, PowerPoint, Photoshop, programación y desarrollo web.</p>
//                                 <p>Cada bloque de contenido incluye teoría clara, videos explicativos, cuestionarios interactivos y desafíos prácticos que te permiten aplicar lo aprendido de forma dinámica y significativa.</p>
//                                 <p>Además, participarás en actividades grupales que fortalecen tu comprensión y fomentan el trabajo colaborativo.</p>
//                                 <p>Tu docente es quien guía tu proceso: establece cuándo iniciar cada bloque, activa los contenidos y da seguimiento a tu avance.</p>
//                                 <p>Las evaluaciones se aplican y califican automáticamente, y puedes consultar tus resultados desde tu perfil.</p>
//                                 <p>Con Ztudia, aprendes a tu ritmo, con autonomía, pero siempre acompañado.</p>
//                             </>
//                         ) : propositionValue === typePropositionValue.INSTRUCTOR && (
//                             <>
//                                 <p>Ztudia es una solución educativa diseñada para facilitar la enseñanza de competencias digitales mediante una estructura clara, completa y lista para usar.</p>
//                                 <p>Ofrece un temario progresivo, organizado por bloques de conocimiento que cubren herramientas clave como Word, Excel, PowerPoint, Photoshop, Principios de Programación, Programación Orientada a Objetos y Desarrollo Web.</p>
//                                 <p>Cada bloque incluye contenido teórico, cuestionarios, videos y desafíos prácticos, todo previamente diseñado para que el docente pueda implementarlo directamente en el aula sin necesidad de crear materiales adicionales.</p>
//                                 <p>Además, incorpora actividades grupales estructuradas que refuerzan el aprendizaje colaborativo, y evaluaciones que se aplican y califican automáticamente, mostrando los resultados en los perfiles del docente y del alumno.</p>
//                                 <p>El docente solo necesita definir fechas y activar los contenidos, lo que simplifica la planificación y ejecución de sus clases.</p>
//                                 <p>Esta automatización y estructura permiten optimizar el tiempo del docente, facilitar la gestión pedagógica y fortalecer la calidad del proceso de enseñanza-aprendizaje.</p>
//                             </>
//                         )}
//                     </div>
//                 </Details>
//             )}

//             {showHelpModal && (
//                 <Details
//                     showCloseModalButtonInContent={false}
//                     extraClassName={'Instructor__Ztudents__Details'}
//                     setShowModal={setShowHelpModal}
//                 >
//                     <div className='Instructor__Ztudents__Details__Container'>
//                         <p className='Instructor__Ztudents__Details__Title'><i className="bi bi-question-circle"></i> Ayuda</p>

//                         {idHelp === HELP_TYPE.ZTUDENT.DASHBOARD ? (
//                             <HelpZtudentDashboard />
//                         ) : idHelp === HELP_TYPE.ZTUDENT.COURSE ? (
//                             <HelpZtudentCourse />
//                         ) : idHelp === HELP_TYPE.ZTUDENT.RESULTS ? (
//                             <HelpZtudentResults />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUPS ? (
//                             <HelpInstructorGroups />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUPS_CREATE ? (
//                             <HelpInstructorGroupsCreate />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUP ? (
//                             <HelpInstructorGroup />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.ZTUDENTS ? (
//                             <HelpInstructorZtudents />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.CHANGE_GROUP ? (
//                             <HelpInstructorChangeGroup />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.AGENDA ? (
//                             <HelpInstructorAgenda />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.PROGRESS ? (
//                             <HelpInstructorProgress />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.RESULTS ? (
//                             <HelpInstructorResults />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.ZTUDENTVIEW ? (
//                             <HelpInstructorZtudentView />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.SYLLABUS ? (
//                             <HelpInstructorSyllabus />
//                         ) : idHelp === HELP_TYPE.INSTRUCTOR.DASHBOARD && (
//                             <HelpInstructorDashboard />
//                         )}
//                     </div>
//                 </Details>
//             )}

//             {showMyAccountModal && (
//                 userData ? (
//                     <Details
//                         showCloseModalButtonInContent={false}
//                         extraClassName={'Instructor__Ztudents__Details'}
//                         setShowModal={setShowMyAccountModal}
//                     >
//                         <div className='Instructor__Ztudents__Details__Container'>
//                             <p className='Instructor__Ztudents__Details__Title'>Mi cuenta</p>

//                             <p>Nombre completo: {userData.name}</p>
//                             <p>Correo electrónico: {userData.email}</p>
//                             <p>Alias: {userData.nickname}</p>
//                         </div>
//                     </Details>
//                 ) : (
//                     <Details
//                         showCloseModalButtonInContent={false}
//                         extraClassName={'Instructor__Ztudents__Details'}
//                         setShowModal={setShowMyAccountModal}
//                     >
//                         <div className='Instructor__Ztudents__Details__Container'>
//                             <p>No ha sido posible obtener la información de tu cuenta.</p>
//                             <p>Inténtalo nuevamente o inténtalo más tarde.</p>
//                         </div>
//                     </Details>
//                 )
//             )}
//         </header>
//     )
// }

//export { Header, HELP_TYPE };